module.exports = "/static/media/guide-icon.2d3a5abf.png";